<template>
  <div v-if="datum" class="popup-content">
    <div class="popup-wrapper">
      <div class="content-box">
        <div>
          <h5 class="data-title">{{ $t('Collaborator') }} {{ datum.jllId }}</h5>

          <span class="data-address">{{ datum.address }}</span>

          <span class="data-caption">{{ $t('currentTravelTime') }}</span>

          <span class="data-main">
            <AnimatedValue :value="actualTime" />
            <small style="font-size: 0.5em">min</small>

            <div class="site-box">
              <span class="site-name">{{ datum.actualSite }}</span>
              <span class="site-address">{{ datum.actualSiteAddress }}</span>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div class="close-container">
      <i class="icon-closethin" @click="$emit('close')" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AnimatedValue from '@/components/AnimatedValue';

export default {
  components: { AnimatedValue },
  props: ['datum'],

  computed: {
    ...mapGetters(['globalFilters']),

    actualTime() {
      if (this.globalFilters.currentMatchingTime === 'custom') {
        return this.datum.actualTime;
      }

      return this.datum.actualSiteData.times[0][this.globalFilters.currentMatchingTime];
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

@keyframes fadeInLeft {
  from {
    transform: translateX(-12px);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
}

@keyframes grow {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes growLeft {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

.popup-content {
  width: 226px;
  white-space: nowrap;
  position: absolute;
  top: -11px;
}

.popup-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
}

.content-box {
  flex: 1;
  overflow: hidden;
  margin-left: -15px;
  padding-left: 15px;

  .data-title {
    font-size: 14px;
    color: #262631;
    margin: 0 0 0.3em;
    font-weight: 900;
    opacity: 0;
    transform: translateX(-12px);
    animation: fadeInLeft ease 0.5s forwards;
    animation-delay: 0.3s;
  }

  .data-address {
    font-size: 12px;
    color: #9d9c9c;
    margin: 0;
    padding-bottom: 4px;
    font-family: 'Source Sans Pro', sans-serif;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    opacity: 0;
    transform: translateX(-12px);
    animation: fadeInLeft ease 0.5s forwards;
    animation-delay: 0.4s;
    position: relative;

    &:after {
      content: ' ';
      display: block;
      position: absolute;
      left: 0;
      width: 0;
      background-color: rgba(#d8d8d8, 0.4);
      animation: growLeft ease 1s forwards;
      animation-delay: 0.5s;
      height: 1px;
      bottom: 0;
    }
  }

  .data-caption {
    display: block;
    font-size: 12px;
    color: #262631;
    margin: 0.4em 0 0.15em;
    opacity: 0;
    transform: translateX(-12px);
    animation: fadeInLeft ease 0.5s forwards;
    animation-delay: 0.6s;
  }

  .data-main {
    font-weight: 100;
    font-family: 'Source Sans Pro', sans-serif;
    display: flex;
    align-items: flex-end;
    font-size: 28px;
    color: #262631;
    margin: 0;
    line-height: 0.85;
    overflow: hidden;
    opacity: 0;
    transform: translateX(-12px);
    animation: fadeInLeft ease 0.5s forwards;
    animation-delay: 0.7s;
  }
}

.close-container {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0.8em 0.5em;
  opacity: 0;
  transform: translateZ(0);
  animation: fadein ease 0.3s forwards;
  animation-delay: 0.9s;

  i {
    cursor: pointer;
    color: #000;
    font-size: 1.875em;
    transition: color 0.3s ease;

    &:hover {
      color: colors.$red-active-color;
    }
  }
}

.site-box {
  flex: 1;
  color: #9d9c9c;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  padding-left: 1em;
  box-sizing: border-box;
  overflow: hidden;

  .site-name {
    font-weight: 800;
    display: block;
    margin-top: 0.3em;
    margin-bottom: 0.4em;
  }

  .site-address {
    white-space: nowrap;
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    width: 100%;
  }
}
</style>
